import { NotificationType, DeliveryType } from './NotificationTypes';

export type UserPreference = {
    userPreferenceId: string;
    userId: string;
    medicalProfileId?: string;
    notificationType: NotificationType;
    deliveryType: DeliveryType;
    isEnabled: boolean;
};
